<template>
    <div class="dialog">
        <custom-plane>
            <div class="plane-left">
                <div class="line-item" v-for="(value, key, index) in listData" :key="index">
                    <div class="item-text">{{ key }}</div>
                    <div class="item-text">{{ value }}</div>
                </div>
            </div>
        </custom-plane>
    </div>
</template>
<script>
export default {
    props: {
        infor: Object
    },
    data() {
        return {
            listData: {
                设备名称:'-',
                设备编号:'-',
                设备编码:'-',
                运行状态:'正常',
                品牌型号: '-',
                采购时间: '-',
                维护信息: '-',
                保养记录: '-'

            }
        }
    },
    watch: {
        infor(val) {
            this.listData['设备名称'] = val.eqpName
            this.listData['设备编号'] = val.businessId
            this.listData['设备编码'] = val.eqpCode
            this.listData['品牌型号'] = val.eqpModel
            this.listData['采购时间'] = val.createTime
        }
    }

}
</script>
<style lang="scss" scoped>
.dialog {
    position: absolute;
    top: 135px;
    right: 43px;
    width: 416px;
    // height: 852px;

    .plane-left {
        width: 100%;
        height: 100%;
        padding: 20px;
        padding-left: 34px;

        .line-item {
            width: 100%;
            height: 30px;
            display: flex;
            justify-content: space-between;
            color: #ffffff;
            font-weight: 500;
            font-size: 18px;
            line-height: 29px;

            &:not(:first-child) {
                margin-top: 20px;
            }
        }
    }

}
</style>